import { createListViewContainer } from 'factories/ListView'
import selectors from 'selectors'
import actions from 'actions/tickets'
import Component from 'components/Tickets'

export default createListViewContainer({ actions, selectors: selectors.tickets })(Component)
